// Add your custom JS here.
import AOS from 'aos';

AOS.init({
    speed: 5000,
    offset: -30
});


// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';


// Look for .hamburger
var hamburger = document.querySelector(".hamburger");
// On click
hamburger.addEventListener("click", function() {
  // Toggle class "is-active"
  hamburger.classList.toggle("is-active");
  // Do something else, like open/close menu
});

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

const swiper = new Swiper('.mySwiper', {
  autoplay: {
    delay: 6500,
    disableOnInteraction: false,
  },
  speed: 2000,
  loop: true,
  parallax: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});